import { useContext, useEffect } from 'react';
import { useAuth } from '@agentnet/auth';
import { getEpayAccount } from 'api/payment/api';
import type { EpayAccountsResponse } from 'api/payment/types';
import useAsync from 'hooks/useAsync';
import { ProfileContext, ProfileContextInterface } from 'hooks/ProfileContext';
import useGlobalMessages from 'ui-kit/components/notification/useGlobalMessages';

export function useEpayAccounts(paymentMethodId?: string) {
  const { getAccessToken } = useAuth();
  const profileCtx: ProfileContextInterface = useContext(ProfileContext) ?? {};
  const { userFirm } = profileCtx;
  const { addGlobalMsg } = useGlobalMessages();

  const fetchAccounts = async () => {
    const token = await getAccessToken();
    const payload = paymentMethodId ? { paymentMethodId } : undefined;
    return (await getEpayAccount(token, userFirm?.firmId ?? '', payload)) as EpayAccountsResponse;
  };

  const { execute, value, status, errors } = useAsync<EpayAccountsResponse>(fetchAccounts, false);

  useEffect(() => {
    if (userFirm?.firmId) execute().then();
  }, [userFirm?.firmId, paymentMethodId]);

  useEffect(() => {
    if (status === 'error') {
      const errorMessages = [...(errors ?? [])];
      errorMessages?.map((err) => {
        addGlobalMsg({ message: err, type: 'error' });
      });
    }
  }, [status]);

  return { accounts: value?.accounts ?? [], status, refetch: execute, response: value };
}
